
export default class HeaderMenuItem {
   _hiddenClass = 'header-menu--item__hidden';
   _visible = true;

   width = 0;

   /** @param {HTMLElement} root */
   constructor(root) {
      this.$root = root;
      this._init();
   }

   _init() {
      this._getElements();
   }

   setVisibility(visible) {
      if (visible) this.show();
      else this.hide();
   }

   hide() {
      this.$root.classList.add(this._hiddenClass);
      this.$link.tabIndex = -1;
      this._visible = false;
   }

   show() {
      this.$root.classList.remove(this._hiddenClass);
      this.$link.removeAttribute('tabindex');
      this._visible = true;
   }

   isVisible() {
      return this._visible;
   }

   updateMetrics() {
      this.width = this.$root.getBoundingClientRect().width;
   }

   _getElements() {
      this.$link = this.$root.querySelector('.header-menu--link');
   }
}